import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDCfBnUzcKZ4lCJwEQRZnQHDngZcwnsxEQ",
  authDomain: "humanvill.firebaseapp.com",
  projectId: "humanvill",
  storageBucket: "humanvill.firebasestorage.app",
  messagingSenderId: "89753360629",
  appId: "1:89753360629:web:cc25006521cf0c5d544dbc",
  measurementId: "G-TB5BZ3F9GH"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
